const translations = {
  common: {
    search: 'Rechercher',
    searching: 'Recherche en cours',
    signIn: 'Se connecter',
    register: "S'inscrire",
    myAccount: 'Mon compte',
    support: 'Support',
    followUs: 'Suivez-nous sur X/Twitter',
    proMembership: 'Abonnement Pro',
    new: 'Nouveau',
    proMember: 'Membre Pro',
    upgrade: 'Améliorer',
    subscribe: "S'abonner",
    manage: 'Gérer',
    cancel: 'Annuler',
    close: 'Fermer',
    or: 'Ou',
    email: 'Adresse e-mail',
    continue: 'Continuer',
    submit: 'Envoyer',
    billing: 'Facturation',
    sort: 'Trier',
    language: 'Langue',
    selectLanguage: 'Sélectionner la langue',
    searchPlaceholder: 'Rechercher...',
    cards: 'Cartes',
    previous: 'Précédent',
    next: 'Suivant',
    pagination: 'Pagination',
    back: 'Retour',
    backToSets: 'Retour aux éditions',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    home: 'Accueil',
    sets: 'Éditions',
    login: 'Connexion',
    loginRequired: 'Veuillez vous connecter pour accéder à cette fonctionnalité',
    adding: 'Ajout en cours...',
  },
  languages: {
    default: 'Par défaut',
    any: 'Tous',
    english: 'Anglais',
    spanish: 'Espagnol',
    french: 'Français',
    german: 'Allemand',
    italian: 'Italien',
    portuguese: 'Portugais',
    japanese: 'Japonais',
    korean: 'Coréen',
    russian: 'Russe',
    simplified_chinese: 'Chinois simplifié',
    traditional_chinese: 'Chinois traditionnel',
    hebrew: 'Hébreu',
    latin: 'Latin',
    ancient_greek: 'Grec ancien',
    arabic: 'Arabe',
    sanskrit: 'Sanskrit',
    phyrexian: 'Phyrexian',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Afficher les filtres Pro',
    hide: '✨ Masquer les filtres Pro',
  },
  search: {
    showing_start: 'Affichage de',
    showing_to: 'à',
    showing_of: 'sur',
    showing_results: 'résultats',
    noResults: 'Aucun résultat trouvé.',
    useSearchTip: 'Utilisez la recherche en haut de la page pour trouver une carte.',
  },
  sort: {
    nameAsc: 'Nom (A à Z)',
    nameDesc: 'Nom (Z à A)',
    cmcAsc: 'Coût de mana (Faible à Élevé)',
    cmcDesc: 'Coût de mana (Élevé à Faible)',
    usdAsc: 'Prix (Faible à Élevé)',
    usdDesc: 'Prix (Élevé à Faible)',
    rarityAsc: 'Rareté (Commune à Mythique)',
    rarityDesc: 'Rareté (Mythique à Commune)',
    releasedDesc: "Date de sortie (Plus récent d'abord)",
    releasedAsc: "Date de sortie (Plus ancien d'abord)",
  },
  pages: {
    search: {
      heading: 'Recherche de Cartes MTG',
    },
    sets: {
      heading: 'Éditions de Cartes',
      latestSets: 'Dernières Éditions',
      upcomingSets: 'Éditions à Venir',
      allSets: 'Toutes les Éditions',
      noResults: 'Aucun résultat trouvé.',
    },
    set: {
      notFound: 'Édition non trouvée.',
      noCards: 'Aucune carte trouvée dans cette édition.',
      addAll: 'Ajouter {{count}} Cartes à la Liste de Proxy',
      addedToList: 'Ajout de {{count}} cartes à la Liste de Proxy',
    },
    tokens: {
      heading: 'Jetons',
    },
    emblems: {
      heading: 'Emblèmes',
    },
    import: {
      heading: 'Importer des cartes dans la Liste de Proxy',
      description: 'Saisissez les noms de toutes les cartes que vous souhaitez ajouter à la Liste de Proxy.',
    },
    topProxies: {
      heading: 'Top Proxies',
      description: 'Voici les 50 cartes proxy MTG les plus populaires sur TCG Stacked.',
    },
  },
  theme: {
    light: 'Clair',
    dark: 'Sombre',
    toggle: 'Changer de thème',
  },
  cta: {
    title: 'Prêt à commencer ?',
    subtitle: "Commencez à créer des proxies dès aujourd'hui.",
    searchByCard: 'Rechercher par carte',
    searchBySet: 'Rechercher par édition',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Éditions',
    tokens: 'Jetons',
    emblems: 'Emblèmes',
    import: 'Importer',
    topProxies: 'Top Proxies',
    customCards: 'Cartes Personnalisées',
    deckBuilder: 'Constructeur de Deck',
    buildDeck: 'Construire un Deck',
    publicDecks: 'Decks Publics',
    favoriteDeck: 'Mes Decks Favoris',
    articles: 'Articles',
    feedback: 'Partager un Avis',
    collection: 'Ma Collection',
    pokemonSets: 'Éditions Pokémon',
    pokemonSearch: 'Rechercher des Cartes Pokémon',
  },
  seo: {
    collection: {
      title: 'Ma Collection de Cartes | TCG Stacked',
      description: 'Gérez votre collection personnelle de cartes. Suivez, organisez et évaluez vos cartes Magic: The Gathering en un seul endroit.',
    },
    home: {
      title: 'TCG Stacked - Cartes proxy de Jeux de Cartes à Collectionner',
      description: 'Accédez à une vaste bibliothèque de cartes proxy de jeux de cartes à collectionner. Visualisez et imprimez facilement des images de cartes pour le jeu occasionnel. Commencez à construire le deck de vos rêves maintenant !',
    },
    sets: {
      title: 'Éditions de Cartes - TCG Stacked',
      description: 'Parcourez toutes les éditions de cartes à collectionner et imprimez des proxies pour votre deck.',
    },
    tokens: {
      title: 'Jetons - TCG Stacked',
      description: 'Améliorez vos parties avec une variété de jetons proxy.',
    },
    emblems: {
      title: 'Emblèmes - TCG Stacked',
      description: 'Imprimez des cartes proxy Emblème pour votre deck.',
    },
    search: {
      title: 'Rechercher des Cartes MTG - MTG Proxies',
      description: 'Trouvez et imprimez facilement des cartes proxy MTG. Utilisez notre outil de recherche pour accéder à une vaste base de données et améliorez votre deck Magic: The Gathering avec des proxies.',
    },
    support: {
      title: 'Support - MTG Proxies',
      description: 'Si vous avez des questions, des commentaires ou souhaitez ajouter un jeton/emblème, envoyez-nous un e-mail.',
    },
    articles: {
      title: 'Articles - MTG Proxies',
      description: 'Articles écrits sur Magic: The Gathering et les cartes proxy.',
    },
    import: {
      title: 'Importer - MTG Proxies',
      description: 'Importez une liste de cartes pour imprimer vos proxies Magic: The Gathering.',
    },
    topProxies: {
      title: 'Top Proxies - MTG Proxies',
      description: 'Voir les cartes proxy Magic: The Gathering les plus populaires.',
    },
    customCards: {
      title: 'Cartes Personnalisées - MTG Proxies',
      description: 'Créez vos propres cartes proxy personnalisées Magic: The Gathering.',
    },
    login: {
      title: 'Connexion - MTG Proxies',
      description: 'Connectez-vous à votre compte pour gérer vos cartes personnalisées, listes de decks et plus encore.',
    },
    register: {
      title: 'Inscription - MTG Proxies',
      description: 'Inscrivez-vous pour gérer vos cartes personnalisées, listes de decks et plus encore.',
    },
    termsOfService: {
      title: 'Conditions de Service - MTG Proxies',
      description: 'Lisez les conditions de service du site.',
    },
    privacyPolicy: {
      title: 'Politique de Confidentialité - MTG Proxies',
      description: 'Lisez la politique de confidentialité du site.',
    },
    account: {
      title: 'Compte - MTG Proxies',
      description: 'Gérez votre compte.',
    },
    proMembership: {
      title: 'Abonnement Pro - MTG Proxies',
      description: "Abonnez-vous à l'Abonnement Pro pour accéder à toutes les fonctionnalités du site.",
    },
    deckBuilder: {
      title: 'Constructeur de Deck - MTG Proxies',
      description: 'Créez et gérez vos decks Magic: The Gathering.',
    },
    deckEditor: {
      title: 'Éditeur de Deck - MTG Proxies',
      description: 'Créez et modifiez vos decks Magic: The Gathering.',
    },
    publicDecks: {
      title: 'Decks Publics - MTG Proxies',
      description: 'Parcourez et découvrez des decks MTG publics partagés par la communauté.',
    },
  },
  pro: {
    pricing: {
      title: 'Boostez Votre Expérience MTG Proxy',
      subtitle: "Passez au Pro et profitez d'une expérience premium sans publicité avec des fonctionnalités exclusives qui amènent vos proxies au niveau supérieur!",
      monthlyPlan: 'Boost Mensuel',
      yearlyPlan: 'Valeur Suprême Annuelle',
      monthlyPrice: '5,00 $ par mois',
      yearlyPrice: '40,00 $ par an',
      subscribeMonthly: 'Démarrer Maintenant',
      subscribeYearly: 'Économisez avec Annuel',
      signInToSubscribe: 'Connectez-vous pour Débloquer Pro',
      manageSubscription: 'Gérer Vos Avantages Pro',
      nextBillingDate: 'Votre prochaine date de paiement',
      benefitsEndDate: "Accès Pro jusqu'au",
      viewInvoice: 'Voir le Reçu',
      changePlan: 'Changer Votre Plan',
      reactivate: 'Restaurer Vos Avantages Pro',
      active: 'Actif et Florissant',
      cancelled: 'Annulé',
      freeTrial: 'Essai Gratuit',
      freeTrialEnds: "L'Essai Gratuit se Termine",
      startFreeTrial: "Commencer l'Essai Gratuit de 7 Jours",
      signInForFreeTrial: "Connectez-vous pour l'Essai Gratuit de 7 Jours",
      current: 'Actuel',
      subscribe: "S'abonner",
    },
    benefits: {
      title: 'Pourquoi Choisir Pro avec TCG Stacked ?',
      subtitle: 'Rejoignez des centaines de joueurs qui ont amélioré leur expérience MTG avec ces fonctionnalités Pro exclusives !',
      noAds: {
        title: 'Expérience Pure Sans Publicité',
        description: "Adieu les interruptions ! Profitez d'une interface impeccable sans publicités, bannières, ni pop-ups. L'expérience MTG à l'état pur.",
      },
      darkMode: {
        title: 'Mode Sombre Épique',
        description: "Doux pour vos yeux et élégant ! Parfait pour les noctambules et les sessions marathon de proxies dans n'importe quelle condition d'éclairage.",
      },
      advancedSearch: {
        title: 'Magie de Recherche Pro',
        description: 'Trouvez exactement ce dont vous avez besoin avec des filtres puissants ! Filtrez par identité de couleur, rareté, type de carte et plus pour construire le deck parfait.',
      },
      multipleDecks: {
        title: 'Création Illimitée de Decks',
        description: 'Paradis pour constructeurs de decks ! Créez et sauvegardez autant de decks que vous le souhaitez – du casual fun aux machines compétitives puissantes.',
      },
      futureFeatures: {
        title: 'Premier Accès aux Nouvelles Fonctionnalités',
        description: "À la pointe de l'innovation ! Les membres Pro ont toujours la primeur sur les nouvelles fonctionnalités passionnantes dès leur sortie.",
      },
      cancelAnytime: {
        title: 'Zéro Risque, Tous les Avantages',
        description: "Liberté totale ! Pas de contrats à long terme ni de frais cachés. Annulez d'un simple clic quand vous le souhaitez.",
      },
      prioritySupport: {
        title: 'Accès Support VIP',
        description: "Évitez l'attente ! Vos questions et préoccupations reçoivent un traitement prioritaire avec notre équipe de support dédiée.",
      },
    },
    features: {
      unlimitedDecks: 'Création illimitée de decks',
      noAds: 'Expérience de proxies sans publicité',
      prioritySupport: 'Accès au support VIP',
      darkMode: 'Interface mode sombre élégante',
      advancedSearch: 'Filtres et outils Pro de recherche',
      futureFeatures: 'Fonctionnalités exclusives à venir',
      cancelAnytime: 'Annulation sans tracas',
    },
    promotion: {
      title: 'Libérez la Création Illimitée de Decks',
      description: 'Brisez les limites ! Passez à Pro maintenant et construisez autant de decks que votre imagination permet.',
      customizeTitle: "Transformez vos Cartes avec la Magie de l'IA",
      customizeDescription: "Passez à Pro et créez jusqu'à 5 variations personnalisées de cartes quotidiennement grâce à notre technologie IA de pointe !",
      banner: 'Essayez Pro gratuitement pendant 7 jours ! Sans publicités, mode sombre, decks illimités et plus encore.',
      tryNow: 'Essayer Maintenant',
    },
    account: {
      title: 'Votre Abonnement Pro',
      description: 'Gérez vos avantages premium',
      subscribeToPro: 'Passez à Pro Maintenant',
    },
  },
  auth: {
    signIn: {
      title: 'Connectez-vous à votre compte',
      withGoogle: 'Continuer avec Google',
      withEmail: 'Ou continuer avec',
      sendMagicLink: 'Envoyer le Lien Magique',
      noAccount: "Vous n'avez pas de compte ?",
      checkEmail: 'Vérifiez votre e-mail pour obtenir un lien de connexion',
      errors: {
        failed: 'Échec de la connexion',
        failedGoogle: 'Échec de la connexion avec Google',
        failedEmail: 'Échec de la connexion par e-mail',
        noEmail: 'Aucun e-mail trouvé',
      },
      terms: 'En me connectant, je confirme avoir lu et accepté les',
    },
    register: {
      title: 'Créez votre compte',
      haveAccount: 'Vous avez déjà un compte ?',
      terms: 'En créant un compte, je confirme avoir lu et accepté les',
    },
    common: {
      termsOfService: 'Conditions de Service',
      privacyPolicy: 'Politique de Confidentialité',
      and: 'et',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['cartes', 'jetons', 'emblèmes', 'planeswalkers', 'commandants', 'terrains', 'créatures', 'artefacts', 'enchantements', 'éphémères'],
      description: 'TCG Stacked vous aide à créer des proxies de cartes de jeux de cartes à collectionner pour vos decks casual gratuitement !',
      search: {
        cards: {
          tab: 'Cartes',
          placeholder: 'Rechercher une carte de jeu à collectionner...',
          error: 'Échec du chargement des cartes aléatoires',
        },
        sets: {
          tab: 'Éditions',
          placeholder: 'Rechercher une édition de jeu de cartes à collectionner...',
        },
        tokens: {
          tab: 'Jetons',
          placeholder: 'Rechercher un jeton de jeu de cartes à collectionner...',
        },
        button: 'Rechercher',
        hint: {
          cards: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos cartes',
          sets: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos éditions',
          tokens: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos jetons',
        },
        aria: {
          searchIcon: 'Icône de recherche',
          searchInput: {
            cards: 'Rechercher des cartes',
            sets: 'Rechercher des éditions',
            tokens: 'Rechercher des jetons',
          },
        },
      },
      images: {
        cardAlt: 'Image de carte Magic',
      },
      processedCount: '🎉 Nous avons traité plus de {{count}} proxies gratuites pour la communauté ! 🎉',
    },
    features: {
      section1: {
        badge: 'Imprimer des Proxies',
        title: 'Imprimer des Cartes Proxy MTG',
        subtitle: "Ajoutez des cartes à votre liste d'impression, imprimez-les et utilisez-les dans vos decks dès aujourd'hui !",
        features: [
          {
            name: "Ajoutez des cartes à votre liste d'impression",
            description: "Recherchez n'importe quelle carte via la page de Recherche ou parcourez les éditions et ajoutez les cartes souhaitées à votre liste d'impression.",
          },
          {
            name: 'Imprimez vos cartes',
            description: "Une fois que vous avez ajouté toutes les cartes souhaitées à votre liste d'impression, vous pouvez les imprimer et les utiliser dans vos decks.",
          },
          {
            name: 'Utilisez-les dans vos decks',
            description: "Une fois vos cartes imprimées, vous pouvez les utiliser dans vos decks. Découpez-les et collez-les sur un terrain de base ou utilisez une pochette avec un terrain de base à l'intérieur.",
          },
        ],
        images: {
          cartScreenshot: "Capture d'écran du panier montrant comment ajouter des cartes à votre liste d'impression",
        },
      },
      section2: {
        badge: 'Constructeur de Deck',
        title: 'Construisez et gérez des Decks Magic: The Gathering',
        subtitle: 'Créez et gérez vos propres decks, ou parcourez les decks publics créés par la communauté.',
        features: [
          {
            name: 'Gérez vos Decks MTG',
            description: 'Tous les utilisateurs peuvent créer et gérer un deck MTG. Les membres Pro peuvent créer un nombre illimité de decks.',
          },
          {
            name: 'Imprimez vos cartes',
            description: "Une fois que vous avez ajouté toutes les cartes souhaitées à votre deck, vous pouvez les ajouter à votre Liste d'Impression en une seule fois.",
          },
          {
            name: 'Parcourez les Decks Publics',
            description: "Ajoutez des decks complets créés par la communauté à votre Liste d'Impression pour tester facilement de nouveaux decks.",
          },
        ],
        images: {
          deckBuilderScreenshot: 'Interface du Constructeur de Deck montrant comment gérer vos decks',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Tous droits réservés.',
    disclaimer: "TCG Stacked n'est pas produit, approuvé, soutenu ou affilié à aucun éditeur de jeux de cartes à collectionner.",
    affiliate: 'En tant que partenaire affilié de TCGplayer, TCG Stacked peut gagner une commission sur les achats éligibles.',
    builtBy: 'Créé par',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: "Conditions d'Utilisation",
    support: 'Support',
  },
  sort: {
    nameAsc: 'Nom (A à Z)',
    nameDesc: 'Nom (Z à A)',
    cmcAsc: 'Coût de Mana (Bas à Haut)',
    cmcDesc: 'Coût de Mana (Haut à Bas)',
    usdAsc: 'Prix (Bas à Haut)',
    usdDesc: 'Prix (Haut à Bas)',
    rarityAsc: 'Rareté (Commune à Mythique)',
    rarityDesc: 'Rareté (Mythique à Commune)',
    releasedDesc: 'Date de Sortie (Plus Récent)',
    releasedAsc: 'Date de Sortie (Plus Ancien)',
  },
  pages: {
    search: {
      heading: 'Recherche',
    },
    sets: {
      heading: 'Éditions de Cartes',
      latestSets: 'Dernières Éditions',
      upcomingSets: 'Éditions à Venir',
      allSets: 'Toutes les Éditions',
      noResults: 'Aucun résultat trouvé.',
    },
    set: {
      notFound: 'Édition non trouvée.',
      noCards: 'Aucune carte trouvée dans cette édition.',
      addAll: "Ajouter {{count}} cartes à la Liste d'Impression",
      addedToList: "{{count}} cartes ajoutées à la Liste d'Impression",
    },
    tokens: {
      heading: 'Jetons',
    },
    emblems: {
      heading: 'Emblèmes',
    },
    import: {
      heading: "Importer des cartes dans la Liste d'Impression",
      description: "Saisissez les noms de toutes les cartes que vous souhaitez ajouter à la Liste d'Impression.",
    },
    topProxies: {
      heading: 'Top Proxies',
      description: 'Voici les 50 cartes proxy Magic: The Gathering les plus populaires sur MTG Proxies.',
    },
  },
  languages: {
    default: 'Par défaut',
    any: 'Tous',
    english: 'Anglais',
    spanish: 'Espagnol',
    french: 'Français',
    german: 'Allemand',
    italian: 'Italien',
    portuguese: 'Portugais',
    japanese: 'Japonais',
    korean: 'Coréen',
    russian: 'Russe',
    simplified_chinese: 'Chinois simplifié',
    traditional_chinese: 'Chinois traditionnel',
    hebrew: 'Hébreu',
    latin: 'Latin',
    ancient_greek: 'Grec ancien',
    arabic: 'Arabe',
    sanskrit: 'Sanskrit',
    phyrexian: 'Phyrexian',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Afficher les filtres Pro',
    hide: '✨ Masquer les filtres Pro',
  },
  search: {
    showing_start: 'Affichage de',
    showing_to: 'à',
    showing_of: 'sur',
    showing_results: 'résultats',
    noResults: 'Aucun résultat trouvé.',
    useSearchTip: 'Utilisez la recherche en haut de la page pour chercher une carte.',
  },
  advancedFilters: {
    colors: 'Couleurs',
    rarity: 'Rareté',
    cardTypes: 'Types de Carte',
    format: 'Format',
    manaValue: 'Valeur de Mana',
    cardName: 'Nom de Carte',
    cardText: 'Texte de Carte',
    specialCharacteristics: 'Caractéristiques Spéciales',
    activeFilters: 'Filtres Actifs',
    clearAll: 'Tout Effacer',
    applyFilters: 'Appliquer les Filtres',
    searchCardName: 'Rechercher un nom de carte...',
    searchCardText: 'Rechercher un texte de carte...',
    namePrefix: 'Nom : ',
    manaPrefix: 'Mana : ',
    textPrefix: 'Texte : ',
    removeFromFilter: '✕',
    selectLanguage: 'Sélectionner la langue',
  },
  card: {
    addToPrintList: "Ajouter à la liste d'impression",
    removeFromPrintList: "Retirer de la liste d'impression",
    cardsInPrintList: "carte dans la liste d'impression",
    cardsInPrintListPlural: "cartes dans la liste d'impression",
    buyOn: 'Acheter sur TCGplayer',
    buyFor: 'Acheter pour ',
    viewDetails: 'Voir les détails',
    type: 'Type',
    manaCost: 'Coût de mana',
    rarity: 'Rareté',
    artist: 'Artiste',
    collectorNumber: 'Numéro de collection',
    oracleText: 'Texte Oracle',
    youMightAlsoLike: 'Vous pourriez aussi aimer...',
    noRecommendations: 'Aucune recommandation disponible pour le moment.',
    details: 'Détails',
    rulings: 'Règles',
    legality: 'Légalité',
    share: 'Partager',
    favorite: 'Favori',
    noRulings: 'Aucune règle disponible pour cette carte.',
    noLegalityInfo: 'Aucune information de légalité disponible pour cette carte.',
    published: 'Publié',
    legal: 'Légal',
    restricted: 'Restreint',
    banned: 'Banni',
    format: 'Format',
    status: 'Statut',
    viewMore: 'Voir plus',
    viewLess: 'Voir moins',
    customizeWithAI: "Personnaliser avec l'IA",
    otherVersions: 'Impressions uniques',
    showUniqueVersions: 'Afficher les impressions uniques',
    hideUniqueVersions: 'Masquer les impressions uniques',
  },
  cart: {
    title: "Liste d'impression",
    closePanel: 'Fermer le panneau',
    empty: "Aucun proxy dans la liste d'impression.",
    addPadding: 'Ajouter de la marge',
    paperSize: 'Taille du papier',
    scale: 'Échelle',
    clearCardList: 'Vider la liste',
    print: 'Imprimer',
    success: 'Succès !',
  },
  setsList: {
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    results: 'résultats',
    searchPlaceholder: 'Rechercher...',
  },
  customizeCardModal: {
    title: "Personnaliser la Carte avec l'IA",
    description: "Décrivez comment vous souhaitez personnaliser cette carte. L'IA générera une nouvelle version tout en conservant le cadre et la structure de la carte.",
    buttonText: "Personnaliser avec l'IA",
    placeholder: 'Décrivez votre variation personnalisée de carte...',
    generateButton: 'Générer une Carte Personnalisée',
    generatingButton: 'Génération en cours...',
    addToPrintListButton: "Ajouter à la Liste d'Impression",
    successMessage: "Carte personnalisée ajoutée à la liste d'impression",
    remainingGenerationsOne: '{{count}} génération restante ce mois-ci',
    remainingGenerationsOther: '{{count}} générations restantes ce mois-ci',
    error: {
      failed: 'Échec de la génération de la carte personnalisée',
    },
  },
  feedback: {
    buttonLabel: 'Commentaires',
    title: 'Partagez vos Commentaires',
    description: 'Nous apprécions votre avis pour améliorer TCG Stacked. Veuillez partager vos réflexions avec nous.',
    categoryLabel: 'Catégorie',
    categories: {
      bug: 'Signalement de Bug',
      feature: 'Demande de Fonctionnalité',
      improvement: "Suggestion d'Amélioration",
      general: 'Commentaire Général',
      other: 'Autre',
    },
    messageLabel: 'Votre Commentaire',
    messagePlaceholder: 'Veuillez partager vos réflexions, suggestions ou signaler un problème...',
    ratingLabel: 'Évaluez votre Expérience (Facultatif)',
    emailLabel: 'Email (Facultatif)',
    emailPlaceholder: 'votre@email.com',
    emailHelp: 'Indiquez votre email si vous souhaitez que nous vous contactions.',
    submitting: 'Envoi en cours...',
    submitButton: 'Envoyer le Commentaire',
    successMessage: 'Merci pour vos commentaires !',
    errorMessage: "Échec de l'envoi des commentaires. Veuillez réessayer.",
  },
  collection: {
    title: 'Ma Collection',
    loginRequired: 'Connexion Requise',
    loginMessage: 'Veuillez vous connecter pour voir votre collection',
    emptyCollection: 'Aucune Carte Trouvée',
    emptyCollectionMessage: 'Votre collection est vide. Ajoutez des cartes depuis la page de détails de la carte ou utilisez la fonction Ajout en Masse.',
    noMatchingCards: 'Aucune carte ne correspond à vos filtres.',
    searchPlaceholder: 'Rechercher des cartes...',
    sortBy: 'Trier par',
    sortName: 'Nom',
    sortPrice: 'Prix',
    sortDate: "Date d'ajout",
    sortQuantity: 'Quantité',
    filterRarity: 'Rareté',
    filterSet: 'Édition',
    allRarities: 'Toutes les raretés',
    allSets: 'Toutes les éditions',
    filters: 'Filtres',
    clearFilters: 'Effacer les filtres',
    sortAscending: 'Tri Ascendant',
    sortDescending: 'Tri Descendant',
    bulkAdd: 'Ajout en Masse',
    bulkAddTitle: "Ajouter des Cartes depuis la Liste d'Impression",
    bulkAddDescription: "Ajoutez toutes les cartes de votre liste d'impression à votre collection.",
    bulkAddCount: '{{count}} cartes seront ajoutées à votre collection.',
    emptyCart: "Votre liste d'impression est vide",
    bulkAddSuccess: 'Cartes ajoutées à la collection',
    bulkAddError: "Échec de l'ajout des cartes à la collection",
    addToCollection: 'Ajouter à la Collection',
    addMore: 'Ajouter Plus',
    inCollection: 'Dans la Collection',
    quickAdd: 'Ajout Rapide',
    searchCards: 'Rechercher des cartes...',
    typeToSearch: 'Tapez au moins 3 caractères pour rechercher',
    noResults: 'Aucun résultat trouvé',
    noCardSelected: 'Aucune carte sélectionnée',
    addCardToCollection: 'Ajouter une Carte à la Collection',
    addCardDescription: 'Spécifiez la quantité à ajouter à votre collection.',
    quantity: 'Quantité',
    price: 'Prix',
    addToCart: "Ajouter à la Liste d'Impression",
    addedToCart: "Collection ajoutée à la liste d'impression",
    stats: 'Statistiques de la Collection',
    totalValue: 'Valeur Totale',
    filteredValue: 'Valeur Filtrée',
    cardCount: 'Nombre de Cartes',
    totalCards: 'cartes au total',
    uniqueCards: 'cartes uniques',
    filteredCards: 'cartes filtrées',
    rarityBreakdown: 'Répartition par Rareté',
    // Export feature
    export: 'Exporter la Collection',
    exporting: 'Exportation en cours...',
    exportSuccess: 'Collection exportée avec succès',
    exportError: "Échec de l'exportation de la collection",
    noCardsToExport: 'Aucune carte à exporter',
    exportCardName: 'Nom de la Carte',
    exportSet: 'Édition',
    exportRarity: 'Rareté',
    exportQuantity: 'Quantité',
    exportPrice: 'Prix',
    exportTotalValue: 'Valeur Totale',
    exportDateAdded: "Date d'Ajout",
    // Quick add feature
    quickAdd: 'Ajout Rapide',
    searchCards: 'Rechercher des cartes à ajouter',
    typeToSearch: 'Tapez au moins 3 caractères pour rechercher',
    noResults: 'Aucun résultat trouvé',
    noCardSelected: 'Aucune carte sélectionnée',
    addCardToCollection: 'Ajouter une Carte à la Collection',
    addCardDescription: 'Spécifiez la quantité à ajouter à votre collection',
    quantity: 'Quantité',
    price: 'Prix',
    // Insights
    insights: 'Aperçus de la Collection',
    noInsightsAvailable: 'Aucun aperçu disponible pour votre collection',
    insightsDescription: 'Statistiques détaillées sur votre collection',
    rarityDistribution: 'Répartition par Rareté',
    topSets: 'Éditions Principales',
    priceDistribution: 'Répartition des Prix',
    // Clear collection feature
    clearCollection: 'Effacer la Collection',
    clearCollectionConfirmTitle: 'Effacer Toute Votre Collection ?',
    clearCollectionConfirmMessage: 'Cette action ne peut pas être annulée. Toutes les cartes de votre collection seront définitivement supprimées.',
    // Edit card in collection
    editCardInCollection: 'Modifier la Carte dans la Collection',
    editCardDescription: 'Mettez à jour les détails de cette carte dans votre collection.',
    viewCardDetails: 'Voir les Détails de la Carte',
    condition: 'État',
    selectCondition: "Sélectionner l'\u00e9tat",
    language: 'Langue',
    selectLanguage: 'Sélectionner la langue',
    finish: 'Finition',
    selectFinish: 'Sélectionner la finition',
    purchasePrice: "Prix d'Achat",
    isProxy: 'Ceci est un proxy',
    saveChanges: 'Enregistrer les Modifications',
    removeCard: 'Supprimer la Carte',
    cardRemoved: 'Carte supprimée de la collection',
    errorRemovingCard: 'Erreur lors de la suppression de la carte de la collection',
    errorSavingChanges: "Erreur lors de l'enregistrement des modifications de la carte",
    // Landing page
    landing: {
      title: 'Gérez Votre Collection MTG',
      description: 'Suivez toutes vos cartes Magic: The Gathering en un seul endroit avec nos puissants outils de gestion de collection.',
      intro: "Notre système de gestion de collection vous permet de suivre, organiser et évaluer facilement toute votre collection de cartes Magic: The Gathering. Créez un compte dès aujourd'hui pour commencer !",
      createAccount: 'Créer un Compte',
      getStarted: 'Commencer Maintenant',
      howItWorks: 'Comment Ça Fonctionne',
      step1: 'Créez un compte gratuit pour accéder à votre collection personnelle',
      step2: 'Ajoutez des cartes à votre collection manuellement ou importez-les depuis un fichier CSV',
      step3: 'Organisez vos cartes par édition, couleur, rareté et plus encore',
      step4: 'Suivez la valeur de votre collection au fil du temps',
      step5: 'Exportez les données de votre collection quand vous en avez besoin',
    },
    features: {
      track: {
        title: 'Suivez Vos Cartes',
        description: 'Tenez un inventaire détaillé de toutes vos cartes Magic: The Gathering en un seul endroit',
      },
      organize: {
        title: 'Organisez par Édition',
        description: 'Triez et filtrez votre collection par édition, rareté, couleur et plus encore',
      },
      value: {
        title: 'Suivez la Valeur',
        description: "Visualisez la valeur marchande actuelle de toute votre collection en un coup d'œil",
      },
      export: {
        title: 'Exportez les Données',
        description: "Exportez les données de votre collection pour les utiliser dans d'autres applications",
      },
    },
  },
  feedback: {
    buttonLabel: 'Commentaires',
    title: 'Partagez Vos Commentaires',
    description: 'Nous apprécions votre avis pour améliorer TCG Stacked. Veuillez partager vos réflexions avec nous.',
    categoryLabel: 'Catégorie',
    categories: {
      bug: 'Signalement de Bug',
      feature: 'Demande de Fonctionnalité',
      improvement: "Suggestion d'Amélioration",
      general: 'Commentaire Général',
      other: 'Autre',
    },
    messageLabel: 'Votre Commentaire',
    messagePlaceholder: 'Veuillez partager vos réflexions, suggestions ou signaler un problème...',
    ratingLabel: 'Évaluez Votre Expérience (Facultatif)',
    emailLabel: 'Email (Facultatif)',
    emailPlaceholder: 'votre@email.com',
    emailHelp: 'Indiquez votre email si vous souhaitez que nous vous contactions.',
    submitting: 'Envoi en cours...',
    submitButton: 'Envoyer le Commentaire',
    successMessage: 'Merci pour votre commentaire !',
    errorMessage: "Échec de l'envoi du commentaire. Veuillez réessayer.",
  },
  customizeCardModal: {
    title: "Personnaliser la Carte avec l'IA",
    description: "Décrivez comment vous souhaitez personnaliser cette carte. L'IA générera une nouvelle version en conservant le cadre et la structure de la carte.",
    buttonText: "Personnaliser avec l'IA",
    placeholder: 'Décrivez votre variation personnalisée de la carte...',
    generateButton: 'Générer une Carte Personnalisée',
    generatingButton: 'Génération en cours...',
    addToPrintListButton: "Ajouter à la Liste d'Impression",
    successMessage: "Carte personnalisée ajoutée à la liste d'impression",
    cancelledGeneration: 'Génération de carte annulée',
    remainingGenerationsOne: '{{count}} génération restante ce mois-ci',
    remainingGenerationsOther: '{{count}} générations restantes ce mois-ci',
    error: {
      failed: 'Échec de la génération de la carte personnalisée',
    },
  },
  // New translations for combined hero component
  hero: {
    game: {
      pokemon: {
        tab: 'Pokémon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: "Rechercher n'importe quelle carte...",
      },
      sets: {
        placeholder: "Rechercher n'importe quelle édition de cartes...",
      },
      button: 'Rechercher',
      hint: {
        cards: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos cartes',
        sets: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos éditions',
      },
      aria: {
        searchIcon: 'Icône de recherche',
        searchInput: {
          cards: 'Rechercher des cartes',
          sets: 'Rechercher des éditions',
        },
      },
    },
  },
  // Pokemon specific translations
  pokemon: {
    advancedFilters: {
      title: 'Filtres Avancés',
      types: 'Types',
      rarities: 'Raretés',
      subtypes: 'Sous-types',
      series: 'Séries',
      sets: 'Éditions',
      legalities: 'Légalités',
      hp: 'PV',
      hpRange: 'Plage de PV',
      hpMin: 'PV Min',
      hpMax: 'PV Max',
      applyFilters: 'Appliquer les Filtres',
      resetFilters: 'Réinitialiser',
      close: 'Fermer',
    },
    search: {
      title: 'Recherche de Cartes Pokémon',
      placeholder: 'Rechercher des cartes Pokémon...',
      advancedFilters: 'Filtres Avancés',
      noResults: "Aucun résultat trouvé. Essayez d'ajuster vos filtres.",
      error: 'Erreur lors de la recherche de cartes Pokémon',
    },
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Dresseurs', 'Énergies', 'Légendaires', 'Brillants'],
      description: 'Recherchez, parcourez et créez des proxies pour les cartes Pokémon.',
      search: {
        cards: {
          tab: 'Cartes',
          placeholder: "Rechercher n'importe quelle carte Pokémon...",
          error: 'Échec de la récupération des cartes Pokémon aléatoires',
        },
        sets: {
          tab: 'Éditions',
          placeholder: "Rechercher n'importe quelle édition de cartes Pokémon...",
        },
        button: 'Rechercher',
        hint: {
          cards: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos cartes',
          sets: 'Appuyez sur Entrée ou cliquez sur Rechercher pour trouver vos éditions',
        },
        aria: {
          searchIcon: 'Icône de recherche',
          searchInput: {
            cards: 'Rechercher des cartes Pokémon',
            sets: 'Rechercher des éditions Pokémon',
          },
        },
      },
      images: {
        cardAlt: 'Image de carte Pokémon',
      },
      processedCount: 'Explorez plus de {{count}} cartes Pokémon dans notre base de données !',
    },
  },
  creditPurchaseModal: {
    title: 'Acheter des Crédits de Génération IA',
    description: 'Achetez des crédits de génération IA supplémentaires pour personnaliser plus de cartes.',
    buttonText: 'Acheter des crédits',
    currentCredits: 'Crédits actuels',
    selectPackage: 'Sélectionner un forfait de crédits',
    purchase: 'Acheter maintenant',
    noCreditsWarning: 'Aucun crédit disponible',
    lowCreditsWarning: 'Peu de crédits restants',
    buyCredits: 'Acheter des crédits',
    remainingGenerationsOne: '{{count}} crédit',
    remainingGenerationsOther: '{{count}} crédits',
    creditPackages: {
      small: 'Petit',
      medium: 'Moyen',
      large: 'Grand',
    },
    loadingCredits: 'Chargement des informations de crédit...',
    valuePerCredit: '${value}/crédit',
    credits: 'Crédits',
    failedCheckout: 'Échec de la création de la session de paiement',
  },

  // Traductions pour la page IA
  ai: {
    pageTitle: "Personnalisez vos cartes proxy avec la magie de l'IA | TCG Stacked",
    pageDescription: 'Transformez vos cartes Magic: The Gathering avec des illustrations personnalisées générées par IA. Exclusif aux membres Pro.',
    hero: {
      badge: 'Fonctionnalité Pro',
      title: "Personnalisez vos cartes proxy avec la magie de l'IA",
      subtitle: 'Créez des illustrations personnalisées pour vos proxies Magic: The Gathering en quelques secondes',
      cta: "Essayez l'abonnement Pro gratuitement",
    },
    features: {
      title: 'Des fonctionnalités IA puissantes à portée de main',
      subtitle: 'Notre personnalisation par IA vous donne un contrôle créatif total sur vos cartes proxy Magic: The Gathering',
      cardIntegrity: {
        title: "Préservation de l'intégrité des cartes",
        description: "Notre IA modifie uniquement l'illustration tout en maintenant parfaitement intact le cadre de la carte, le texte, les symboles de mana et la mise en page.",
      },
      creativity: {
        title: 'Créativité illimitée',
        description: "Transformez vos cartes avec n'importe quel thème ou style que vous pouvez imaginer - de la fantasy à la science-fiction, du photoréalisme à l'abstrait.",
      },
      instantResults: {
        title: 'Résultats instantanés',
        description: 'Générez des illustrations personnalisées en quelques secondes sans compétences en design. Décrivez simplement ce que vous voulez voir.',
      },
      saveCreations: {
        title: 'Sauvegardez vos créations',
        description: 'Toutes vos cartes générées par IA sont enregistrées dans votre compte pour que vous puissiez y accéder à tout moment depuis votre tableau de bord.',
      },
      printAnytime: {
        title: 'Imprimez à tout moment',
        description: 'Ajoutez vos cartes personnalisées à votre liste de proxy quand vous le souhaitez et imprimez-les avec le reste de votre collection.',
      },
    },
    credits: {
      title: 'Crédits de génération IA',
      subtitle: 'Personnalisez et transformez vos cartes proxy Magic: The Gathering avec des crédits de génération IA puissants, abordables et faciles à utiliser.',
      howItWorks: 'Comment fonctionnent les crédits',
      step1: {
        number: '1',
        title: 'Achetez des crédits',
        description: 'en forfaits adaptés à vos besoins créatifs et à votre budget',
      },
      step2: {
        number: '2',
        title: 'Générez des illustrations personnalisées',
        description: "pour n'importe quelle carte proxy Magic: The Gathering en utilisant 1 crédit par génération",
      },
      step3: {
        number: '3',
        title: 'Suivez votre utilisation',
        description: 'dans le tableau de bord de votre compte et achetez-en plus à tout moment',
      },
      proAdvantage: {
        title: 'Avantage membre Pro',
        description: 'Les membres Pro reçoivent 5 crédits de génération IA mensuels dans le cadre de leur abonnement. Rejoignez Pro pour maximiser votre potentiel créatif !',
      },
      purchaseButton: 'Acheter des crédits maintenant',
      unlockProButton: "Débloquer l'abonnement Pro",
      packages: {
        title: 'Forfaits de crédits',
        small: {
          name: 'Petit',
          credits: '5',
          price: '2.99',
          value: '0,60 $/crédit',
        },
        medium: {
          name: 'Moyen',
          credits: '15',
          price: '7.99',
          value: '0,53 $/crédit',
          popular: 'Populaire',
        },
        large: {
          name: 'Grand',
          credits: '30',
          price: '13.99',
          value: '0,47 $/crédit',
        },
        createDesigns: 'Créez {{credits}} designs de cartes uniques',
      },
    },
  },
};

export default translations;
